import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { useFetchData } from "../../../hooks/useFetch";
import { API_PROMOTION_CAMPAIGN_TYPES_ROUTER, ApiConfig } from "../../../services/api-config";
import { PAGE_SIZES, } from "../../../constants/status";
import { PromotionCampaign } from "../../../models/response/promotion-campaign";
import { showToast } from "../../../components/custom/custom-toast";
import { PromotionCampaignBrandFilter } from "./promotion-campaign-type-brand-filter";
import { PromotionCampaignBrand } from "../../../models/response/promotion-campaign-brand";

interface PromotionCampaignBrandTableProps {
  item: PromotionCampaign;
}

const PromotionCampaignBrandTable = (props: PromotionCampaignBrandTableProps) => {
  const { item } = props;
  const [keySearch, setKeySearch] = useState("");
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(PAGE_SIZES[0]);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const [promotionCampaignBrands, setPromotionCampaignBrands] = useState<PromotionCampaignBrand[]>([]);
  const { request: getPromotionsCampaign, baseResponse: promotionsCampaignRes, loading: tableLoading } = useFetchData.Get<any>({ projectId: ApiConfig.PROJECT_ID.USER_SERVICE });


  useEffect(() => {
    setPage(1);
  },[keySearch, dateFrom, dateTo, limit])

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        page,
        limit,
        key_search: keySearch,
        promotion_campaign_type_id: item?._id,
        assign_from: dateFrom,
        assign_to: dateTo
      };
      await getPromotionsCampaign({
        endPoint: API_PROMOTION_CAMPAIGN_TYPES_ROUTER.API_GET_PROMOTION_CAMPAIGNS_LIST_BRAND(),
        data: params,
      });
    };

    fetchData();
  }, [page, limit, keySearch, dateFrom, dateTo, item]);

  useEffect(() => {
    if (!promotionsCampaignRes) return;
    if (promotionsCampaignRes?.data && promotionsCampaignRes?.status === 200) {
      setPromotionCampaignBrands(promotionsCampaignRes.data.list);
      setTotalRecords(promotionsCampaignRes.data.total_record);
    } else {
      showToast({
        message: promotionsCampaignRes?.message ?? "Không thể tải danh sách",
        type: "error",
      });
    }
  }, [promotionsCampaignRes]);

  return (
    <div className="panel flex flex-col gap-3">
      <PromotionCampaignBrandFilter
        searchValue={keySearch}
        setSearchValue={setKeySearch}
        item={item}
        onTimeFromChange={setDateFrom}
        onTimeToChange={setDateTo}
      />

      <div className="datatables h-[55vh]" >
        <DataTable
          fetching={tableLoading}
          withColumnBorders
          noRecordsText="Không có kết quả nào phù hợp với truy vấn tìm kiếm"
          highlightOnHover
          className="whitespace-nowrap table-hover custom-scroll"
          records={promotionCampaignBrands}
          columns={[
            {
              accessor: "_id",
              title: "STT",
              width: "5%",
              textAlignment: "center",
              render: (record, index) => <div>{(page - 1) * limit + index + 1}</div>
            },
            {
              accessor: "name",
              title: "Tên thương hiệu",
              width: "55%",
              titleClassName: "!text-center",
              render: (record) => <div className="">{record.brand.name}</div>
            },
            {
              accessor: "name",
              title: "Số điện thoại",
              width: "20%",
              titleClassName: "!text-center",
              textAlignment: "center",
              render: (record) => <div className="">{record.brand.phone}</div>
            },
            {
              accessor: "updated_at",
              title: "Thời gian gán",
              titleClassName: "!text-center",
              width: "20%",
              render: (record) => <div key={record._id} className="text-center">{record.updated_at}</div>,
            }
          ]}
          totalRecords={totalRecords}
          recordsPerPage={limit}
          page={page}
          onPageChange={(p) => setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={setLimit}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) =>
            `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`
          }
        />
      </div>
    </div>
  );
};

export default PromotionCampaignBrandTable;
